import React from "react";

export default function ContactInfo() {
  const contactDetails = [
    {
      icon: "pi pi-map-marker",
      label: "Adres",
      value: "Kurtuluş OSB, Taşlıyol Cd. No:3, 16580 Gürsu/Bursa",
    },
    {
      icon: "pi pi-phone",
      label: "Telefon",
      value: "(0224) 371 54 10",
    },
    {
      icon: "pi pi-envelope",
      label: "E-posta",
      value: "info@boyertekstil.com",
    },
    {
      icon: "pi pi-globe",
      label: "Web Sitesi",
      value: "www.boyertekstil.com",
    },
  ];

  return (
    <div className="flex  items-center justify-center    ">
      <div className=" w-full p-4">
        <h2 className="text-2xl font-bold text-center mb-4">
          İletişim Bilgilerimiz
        </h2>
        <p className="text-center mb-6">
          Sorularınız için bizimle aşağıdaki bilgilerden iletişime geçebilirsiniz.
        </p>
        <ul className=" p-0 m-0">
          {contactDetails.map((detail, index) => (
            <li
              key={index}
              className="flex items-center gap-4 p-4 mb-3  p-card rounded-md shadow-sm"
            >
              <i className={`${detail.icon} text-blue-500 text-xl`}></i>
              <div>
                <span className="block font-semibold">{detail.label}</span>
                <span className="block text-sm">{detail.value}</span>
              </div>
            </li>
          ))}
        </ul>
      </div>
  
    </div>
  );
}
